import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
@Component({
  selector: 'app-health-brand',
  templateUrl: './health-brand.component.html',
  styleUrls: ['./health-brand.component.scss']
})
export class HealthBrandComponent implements OnInit {

  @Input() dataReport: any
  title_report = 'Thống kê nổi bật '; 
  result = [];
  contentRight = '';

  public barChartOptions = {
    plugins: {
      labels: {
        render: 'value',
        fontColor: 'black',
        precision: 2,
        arc: true,
        fontSize: 14,
        fontStyle: 'bold'
      }
    }
  };
  public barChartLabels = ['Vinaphone', 'VNPT', 'Mobifone', 'VietnamMobile'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData = [
    // { data: [65, 59, 80, 81], label: 'Số thảo luận' },
    // { data: [28, 48, 40, 19], label: 'Chỉ số NSR' }
  ];
  public barChartColors: Color[] = [
    { backgroundColor: '#00b0f0' },
    { backgroundColor: '#c10e45' }
  ]


  constructor() {
    console.log(this.dataReport)
  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport)
    this.mappingData()
    // changes.prop contains the old and the new value...
  }
  
  mappingData() {
    if(this.dataReport && this.dataReport.data && this.dataReport.data.result) {
      if(this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }
      let discussion_number = { data: [], label: 'Số thảo luận' };
      let nsr_number =  { data: [], label: 'Chỉ số NSR' };
      this.barChartLabels = [];
      this.dataReport.data.result.forEach(reportItem => {
        let discuss_value = reportItem.totalNews +  reportItem.totalPosts + reportItem.commentCount;
        discussion_number.data.push(discuss_value);
        nsr_number.data.push(reportItem.nsr)
        this.barChartLabels.push(reportItem.name)
      });
      this.barChartData = [];
      this.barChartData.push(discussion_number,nsr_number);
      this.result = this.dataReport.data.result;
      this.contentRight = this.dataReport.data.contentRight;
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/health-brand/health-brand.component.ts